var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"center"},[_c('h3',{staticClass:"lobster"},[_vm._v(_vm._s(_vm.$t("home.welcome_msg")))]),_c('p',[_vm._v(_vm._s(_vm.$t("home.help_msg")))]),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.next()}}},[_vm._v(_vm._s(_vm.$t("home.start_btn")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }